import type { ForwardedRef, ReactNode } from 'react';

import { forwardRef, memo } from 'react';
import { Provider } from 'react-redux';

import type { StoreProviderProps, StoreProviderRef } from './_.type';

import { store } from '../_store';
import useStoreProviderHooks from './_.hook';

/** StoreProvider. */
export default memo(
  forwardRef(function StoreProvider(props: StoreProviderProps, ref: ForwardedRef<StoreProviderRef>): ReactNode {
    const { children } = props;

    useStoreProviderHooks(props, ref);

    return <Provider store={store}>{children}</Provider>;
  }),
);
